import { useState, useCallback } from 'react';
import type { TaskModalMode } from '../components/tasks';

export interface TaskModalState {
  isOpen: boolean;
  mode: TaskModalMode;
  taskHistory: string[];
  historyIndex: number;
  taskId?: string;
}

export function useTaskModalState() {
  const [state, setState] = useState<TaskModalState | null>(null);

  const openCreate = useCallback(() => {
    setState({ isOpen: true, mode: 'create', taskHistory: [], historyIndex: -1 });
  }, []);

  const openEdit = useCallback((taskId: string, allTaskIds: string[]) => {
    const idx = allTaskIds.indexOf(taskId);
    setState({
      isOpen: true,
      mode: 'edit',
      taskHistory: allTaskIds,
      historyIndex: idx >= 0 ? idx : 0,
      taskId,
    });
  }, []);

  const close = useCallback(() => {
    setState(null);
  }, []);

  const navigate = useCallback((navTaskId: string, newIndex: number) => {
    setState(prev => {
      if (!prev) return prev;
      if (navTaskId === '__create__') {
        return { ...prev, mode: 'create' as TaskModalMode, taskId: undefined, historyIndex: newIndex };
      }
      return { ...prev, mode: 'edit' as TaskModalMode, taskId: navTaskId, historyIndex: newIndex };
    });
  }, []);

  return {
    state,
    isOpen: !!state?.isOpen,
    mode: state?.mode ?? 'create',
    taskId: state?.taskId,
    taskHistory: state?.taskHistory ?? [],
    historyIndex: state?.historyIndex ?? -1,
    openCreate,
    openEdit,
    close,
    navigate,
  };
}
